import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FiFileText, FiHome, FiChevronRight, FiShield } from "react-icons/fi";

const Terms = () => {
  const [termsContent, setTermsContent] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/cust_api/get-term-conditions`
        );

        if (response.status === 200 && response.data.status === 1) {
          const content = response.data.data?.[0]?.content;
          setTermsContent(content);
        } else {
          setError("Terms and conditions content is not available.");
        }
      } catch (err) {
        setError("Failed to load terms and conditions.");
      }
    };

    fetchTerms();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="px-4 sm:px-10 pt-6 pb-10 bg-white font-sans overflow-hidden">
      <div className="mx-auto w-full max-w-[1400px]">
        {/* HEADER */}
        <div className="mb-6 flex flex-col gap-4 rounded-3xl border border-gray-100 bg-gradient-to-br from-white to-[#700c28]/5 px-5 py-5 shadow-sm sm:flex-row sm:items-end sm:justify-between sm:px-8">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-[#700c28]/10 px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-[#700c28]">
              <FiShield size={10} /> Legal
            </span>

            <h1 className="mt-2 text-2xl sm:text-4xl font-extrabold tracking-tight text-[#1a1a1a]">
              Terms{" "}
              <span className="bg-gradient-to-r from-[#700c28] to-[#b5173f] bg-clip-text text-transparent">
                & Conditions
              </span>
            </h1>

            <p className="mt-2 max-w-2xl text-sm sm:text-base text-gray-500">
              Please read these terms carefully before using the website.
            </p>
          </div>

          <div className="flex items-center gap-2 text-xs text-gray-500">
            <Link
              to="/"
              className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-white px-3 py-1.5 font-medium hover:border-[#700c28] hover:text-[#700c28]"
            >
              <FiHome size={13} /> Home
            </Link>
            <FiChevronRight size={13} />
            <span className="inline-flex items-center rounded-full bg-[#700c28]/10 px-3 py-1.5 font-medium text-[#700c28]">
              Terms & Conditions
            </span>
          </div>
        </div>

        {/* CONTENT */}
        {error ? (
          <div className="rounded-2xl border border-red-100 bg-red-50 px-5 py-4 text-sm text-red-600">
            {error}
          </div>
        ) : termsContent ? (
          <div className="rounded-3xl border border-gray-100 bg-white p-5 sm:p-8 shadow-[0_10px_30px_rgba(0,0,0,0.04)]">
            <div className="mb-5 flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-[#700c28]/10 text-[#700c28]">
                <FiFileText size={18} />
              </div>
              <div>
                <h2 className="text-lg font-bold text-[#1a1a1a]">Policy Details</h2>
                <p className="text-sm text-gray-500">
                  Updated terms and conditions for users
                </p>
              </div>
            </div>

            <div
              className="terms-content leading-7 text-gray-700 prose max-w-none prose-headings:text-[#1a1a1a] prose-a:text-[#700c28] prose-strong:text-[#1a1a1a]"
              dangerouslySetInnerHTML={{ __html: termsContent }}
            />
          </div>
        ) : (
          <div className="rounded-2xl border border-gray-100 bg-gray-50 px-5 py-8 text-sm text-gray-500">
            Loading terms and conditions...
          </div>
        )}
      </div>
    </section>
  );
};

export default Terms;
